import { parseISO, format, getYear, getMonth } from 'date-fns';
import { it } from 'date-fns/locale';

const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

// 'HH:mm dd/MM/yyyy' (stesso formato usato finora nell'app)
export function formatEventDateTime(iso) {
  try {
    return format(parseISO(iso), 'HH:mm dd/MM/yyyy');
  } catch (error) {
    return 'Data non valida';
  }
}

// "Settembre 2026"
export function monthLabel(year, month1) {
  return capitalize(format(new Date(year, month1 - 1, 1), 'LLLL yyyy', { locale: it }));
}

// "Settembre"
export function monthName(month1) {
  return capitalize(format(new Date(2000, month1 - 1, 1), 'LLLL', { locale: it }));
}

// Raggruppa per mese preservando l'ordine in ingresso: [{ key: 'yyyy-MM', year, month, events }]
export function groupByMonth(events) {
  const groups = [];
  const index = new Map();
  events.forEach((event) => {
    const date = parseISO(event.when);
    const year = getYear(date);
    const month = getMonth(date) + 1;
    const key = `${year}-${String(month).padStart(2, '0')}`;
    if (!index.has(key)) {
      index.set(key, groups.length);
      groups.push({ key, year, month, events: [] });
    }
    groups[index.get(key)].events.push(event);
  });
  return groups;
}

// Raggruppa per anno e mese preservando l'ordine in ingresso: [{ year, count, months: [{ month, events }] }]
export function groupByYearMonth(events) {
  const years = [];
  const yearIndex = new Map();
  groupByMonth(events).forEach((group) => {
    if (!yearIndex.has(group.year)) {
      yearIndex.set(group.year, years.length);
      years.push({ year: group.year, count: 0, months: [] });
    }
    const entry = years[yearIndex.get(group.year)];
    entry.months.push({ month: group.month, events: group.events });
    entry.count += group.events.length;
  });
  return years;
}

// 'yyyy-MM' di una data ISO, usato per il parametro ?month delle liste
export function monthKeyOf(iso) {
  const date = parseISO(iso);
  return `${getYear(date)}-${String(getMonth(date) + 1).padStart(2, '0')}`;
}

// Valore per <input type="datetime-local"> ('yyyy-MM-ddTHH:mm') nell'ora locale del browser
export function toDateTimeLocal(iso) {
  try {
    return format(parseISO(iso), "yyyy-MM-dd'T'HH:mm");
  } catch (error) {
    return '';
  }
}
